import { useContext } from 'react';
import { PropertiesContext, PropertiesContextProvider } from '../contexts/properties/context';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesContextHOC = ({
  children,
  apiWrapper
}) => {
  const ctx = useContext(PropertiesContext);
  if (ctx !== null && ctx !== void 0 && ctx.propertiesActions) {
    return children;
  }
  return /*#__PURE__*/_jsx(PropertiesContextProvider, {
    apiWrapper: apiWrapper,
    children: children
  });
};
export default PropertiesContextHOC;